import React, { useMemo } from 'react';

export const BackgroundStars: React.FC = () => {
  // Создаем звезды с фиксированными позициями при первом рендере
  const stars = useMemo(() => Array(12).fill(0).map((_, index) => ({
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 5}s`,
    animationDuration: `${10 + Math.random() * 15}s`,
    opacity: Math.random() * 0.5 + 0.2,
    scale: Math.random() * 0.5 + 0.3,
    key: index
  })), []);

  return (
    <div className="background-stars">
      {stars.map((star) => (
        <div 
          key={star.key}
          className="bg-star"
          style={{
            left: star.left,
            top: star.top,
            animationDelay: star.animationDelay,
            animationDuration: star.animationDuration,
            opacity: star.opacity,
            transform: `scale(${star.scale})`,
          }}
        >⭐</div>
      ))}
    </div>
  );
}; 